import React, { FC } from 'react'

import { WithChildren } from 'common/types'
import { SmallNoteText } from 'components/block/PhotoLine/PhotoLineTooltip.styled'
import {
  HideIfTypingContainer,
  UserTypingWrapper,
} from 'components/page/Chat/Messenger/MessengerEditor/MessengerEditor.styled'
import { TypingProcess } from 'components/page/Chat/Messenger/MessengerHeader/LocationAndStatusWriting'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { chatMessengerReducer } from 'reducers/messenger/chatMessengerReducer'

export const SwitchTyping: FC<{ userId: number } & WithChildren> = ({
  userId,
  children,
}) => {
  /**
   * По-идее оверхед тащить ради того, чтобы узнать, печатает ли юзер или нет весь чат редьюсер.
   * Но в целом все равно почти везде PWA.
   */
  useReducersInsert({ chatMessengerReducer })

  const { isTyping } = useShallowEqualSelector(
    ({ chatMessengerReducer: { typingUser } }) => ({
      isTyping: typingUser === userId,
    })
  )

  return (
    <UserTypingWrapper>
      <HideIfTypingContainer $isTyping={isTyping}>
        {children}
      </HideIfTypingContainer>
      <SmallNoteText>
        <TypingProcess isTyping={isTyping} />
      </SmallNoteText>
    </UserTypingWrapper>
  )
}
